import { clearUcAndSkillhubLeadStorage } from '@repo/common-utils/utils/ucSessionAndLeadStorage'
import { reconcileLocaleStorage } from '@repo/common-utils/utils/appLocale'

const THEME_KEY = 'skillhub-theme'
const DEFAULT_THEME = 'light'

export function applySkillhubStartupState(): void {
  if (typeof window === 'undefined') return

  try {
    reconcileLocaleStorage()
    if (!localStorage.getItem(THEME_KEY)) {
      localStorage.setItem(THEME_KEY, DEFAULT_THEME)
    }
    clearUcAndSkillhubLeadStorage()
  } catch {
    /* ignore startup storage errors */
  }

  if (typeof document !== 'undefined') {
    document.documentElement.dataset.skillhubTheme = DEFAULT_THEME
  }
}
